import React from 'react';
import { NORME_STATES, NOT_READ } from '../lib/ruleDots';

// One dot of the « Règles de zonage » card: the state its norme was read in, or « not read ».
export const NormeDot = ({ dot, states }) => {
  const state = dot ? states?.[dot] : undefined;
  const shown = NORME_STATES[state] || NOT_READ;
  return (
    <span
      className={`w-2 h-2 rounded-full ${shown.color}`}
      title={shown.label}
      aria-label={shown.label}
      data-testid={dot ? `rule-dot-${dot}` : undefined}
      data-state={NORME_STATES[state] ? state : 'not_read'}
    />
  );
};

export default NormeDot;
